 document.addEventListener('DOMContentLoaded', function() {
  console.log('Income slider script loaded');
  
  // Wait a bit for Shopify to fully load
  setTimeout(function() {
    initIncomeSlider();
  }, 500);
  
  function initIncomeSlider() {
    const slides = document.querySelectorAll('.income-testimonial-slide');
    const dots = document.querySelectorAll('.income-nav-dot');
    const sliderWrapper = document.querySelector('.income-testimonial-slider-wrapper');
    
    console.log('Found income slides:', slides.length);
    console.log('Found income dots:', dots.length);
    
    if (slides.length === 0 || !sliderWrapper) {
      console.log('No income slides found, exiting');
      return;
    }
    
    let currentSlide = 0;
    let autoSlideTimer = null;
    let isSliderVisible = false;
    
    // Intersection Observer to detect when slider is visible
    const observerOptions = {
      root: null,
      rootMargin: '50px',
      threshold: 0.3
    };
    
    const sliderObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.target === sliderWrapper) {
          isSliderVisible = entry.isIntersecting;
          console.log('Slider visibility changed:', isSliderVisible);
          
          if (isSliderVisible && slides.length > 1) {
            startAutoSlide();
          } else {
            stopAutoSlide();
          }
        }
      });
    }, observerOptions);
    
    // Start observing the slider
    sliderObserver.observe(sliderWrapper);
    
    function showSlide(index) {
      console.log('Showing income slide:', index);
      
      // Store current scroll position
      const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      // Remove active from all
      slides.forEach(function(slide) {
        slide.classList.remove('active');
      });
      dots.forEach(function(dot) {
        dot.classList.remove('active');
      });
      
      // Add active to current
      if (slides[index]) {
        slides[index].classList.add('active');
        
        // Update images visibility for desktop (show 3 images based on current slide)
        updateImagesVisibility(slides[index], index);
      }
      if (dots[index]) {
        dots[index].classList.add('active');
      }
      
      currentSlide = index;
      
      // Restore scroll position to prevent page jumping
      setTimeout(function() {
        if (window.pageYOffset !== currentScrollY) {
          window.scrollTo(0, currentScrollY);
        }
      }, 10);
    }
    
    function updateImagesVisibility(currentSlideElement, slideIndex) {
      const images = currentSlideElement.querySelectorAll('.income-testimonial-image');
      const isMobile = window.innerWidth <= 768;
      
      if (!isMobile) {
        // Desktop: Show first 3 images, hide others
        images.forEach(function(image, index) {
          if (index < 3) {
            image.classList.remove('hidden');
          } else {
            image.classList.add('hidden');
          }
        });
      } else {
        // Mobile: Show all images with center focus
        images.forEach(function(image, index) {
          image.classList.remove('hidden');
          
          // Calculate center image based on current slide and available images
          const centerIndex = Math.floor(images.length / 2);
          if (index === centerIndex) {
            image.classList.add('center');
          } else {
            image.classList.remove('center');
          }
        });
        
        // Auto-scroll to center image without affecting page scroll
        const imagesContainer = currentSlideElement.querySelector('.income-testimonial-images');
        const centerImage = currentSlideElement.querySelector('.income-testimonial-image.center');
        
        if (imagesContainer && centerImage) {
          setTimeout(function() {
            // Use scrollLeft instead of scrollIntoView to avoid page jumping
            const containerRect = imagesContainer.getBoundingClientRect();
            const imageRect = centerImage.getBoundingClientRect();
            const scrollLeft = imageRect.left - containerRect.left + imagesContainer.scrollLeft - (containerRect.width / 2) + (imageRect.width / 2);
            
            imagesContainer.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }, 100);
        }
      }
    }
    
    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }
    
    function startAutoSlide() {
      if (slides.length <= 1 || !isSliderVisible) return;
      
      stopAutoSlide();
      autoSlideTimer = setInterval(function() {
        // Double-check visibility before auto-advancing
        if (isSliderVisible) {
          nextSlide();
        } else {
          stopAutoSlide();
        }
      }, 4000); // 4 seconds
      
      console.log('Income auto-slide started (visible)');
    }
    
    function stopAutoSlide() {
      if (autoSlideTimer) {
        clearInterval(autoSlideTimer);
        autoSlideTimer = null;
        console.log('Income auto-slide stopped');
      }
    }
    
    // Dot click handlers with scroll position preservation
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Income dot clicked:', index);
        
        // Store scroll position before slide change
        const scrollY = window.pageYOffset;
        
        showSlide(index);
        stopAutoSlide();
        
        // Ensure scroll position is maintained
        requestAnimationFrame(function() {
          if (window.pageYOffset !== scrollY) {
            window.scrollTo(0, scrollY);
          }
        });
        
        // Restart after 3 seconds only if visible
        setTimeout(function() {
          if (isSliderVisible) {
            startAutoSlide();
          }
        }, 3000);
      });
    });
    
    // Mouse hover handlers - only work when visible
    const wrapper = document.querySelector('.income-testimonial-slider-wrapper');
    if (wrapper) {
      wrapper.addEventListener('mouseenter', function() {
        if (isSliderVisible) {
          stopAutoSlide();
        }
      });
      
      wrapper.addEventListener('mouseleave', function() {
        if (isSliderVisible && slides.length > 1) {
          startAutoSlide();
        }
      });
    }
    
    // Touch swipe for mobile with better scroll handling
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSliderSwipe = false;
    
    const slider = document.querySelector('.income-testimonial-slider');
    if (slider) {
      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSliderSwipe = false;
      }, { passive: true });
      
      slider.addEventListener('touchmove', function(e) {
        if (!touchStartX || !touchStartY) return;
        
        const currentX = e.changedTouches[0].screenX;
        const currentY = e.changedTouches[0].screenY;
        
        const diffX = Math.abs(currentX - touchStartX);
        const diffY = Math.abs(currentY - touchStartY);
        
        // Only prevent default if horizontal swipe is more significant than vertical
        if (diffX > diffY && diffX > 30) {
          isSliderSwipe = true;
          e.preventDefault();
          stopAutoSlide();
        }
      }, { passive: false });
      
      slider.addEventListener('touchend', function(e) {
        if (!isSliderSwipe) return;
        
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        handleSwipe();
        
        // Restart after swipe only if visible
        setTimeout(function() {
          if (isSliderVisible) {
            startAutoSlide();
          }
        }, 3000);
      }, { passive: true });
    }
    
    // Separate image swipe handling with better scroll detection
    slides.forEach(function(slide) {
      const imagesContainer = slide.querySelector('.income-testimonial-images');
     
 if (imagesContainer) {
        let imageStartX = 0;
        let imageStartY = 0;
        let imageEndX = 0;
        let isImageSwipe = false;
        
        imagesContainer.addEventListener('touchstart', function(e) {
          imageStartX = e.changedTouches[0].screenX;
          imageStartY = e.changedTouches[0].screenY;
          isImageSwipe = false;
        }, { passive: true });
        
        imagesContainer.addEventListener('touchmove', function(e) {
          if (!imageStartX || !imageStartY) return;
          
          const currentX = e.changedTouches[0].screenX;
          const currentY = e.changedTouches[0].screenY;
          
          const diffX = Math.abs(currentX - imageStartX);
          const diffY = Math.abs(currentY - imageStartY);
          
          // Only handle horizontal swipes on images, allow vertical scroll
          if (diffX > diffY && diffX > 20) {
            isImageSwipe = true;
            // Don't prevent default - let the horizontal scroll work naturally
          }
        }, { passive: true });
        
        imagesContainer.addEventListener('touchend', function(e) {
          if (!isImageSwipe) return;
          
          imageEndX = e.changedTouches[0].screenX;
          handleImageSwipe(slide);
        }, { passive: true });
        
        function handleImageSwipe(slideElement) {
          const swipeDistance = imageStartX - imageEndX;
          const minSwipeDistance = 50;
          const isMobile = window.innerWidth <= 768;
          
          if (!isMobile || Math.abs(swipeDistance) < minSwipeDistance) return;
          
          const images = slideElement.querySelectorAll('.income-testimonial-image');
          const currentCenter = slideElement.querySelector('.income-testimonial-image.center');
          let currentIndex = 0;
          
          // Find current center index
          images.forEach(function(img, index) {
            if (img === currentCenter) {
              currentIndex = index;
            }
          });
          
          let newIndex = currentIndex;
          if (swipeDistance > 0 && currentIndex < images.length - 1) {
            // Swipe left - next image
            newIndex = currentIndex + 1;
          } else if (swipeDistance < 0 && currentIndex > 0) {
            // Swipe right - previous image
            newIndex = currentIndex - 1;
          }
          
          // Update center image without affecting page scroll
          images.forEach(function(img, index) {
            if (index === newIndex) {
              img.classList.add('center');
              
              // Use container scrollTo instead of scrollIntoView
              const container = slideElement.querySelector('.income-testimonial-images');
              if (container) {
                const containerRect = container.getBoundingClientRect();
                const imageRect = img.getBoundingClientRect();
                const scrollLeft = imageRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (imageRect.width / 2);
                
                container.scrollTo({
                  left: scrollLeft,
                  behavior: 'smooth'
                });
              }
            } else {
              img.classList.remove('center');
            }
          });
        }
      }
    });
    
    function handleSwipe() {
      const swipeDistance = touchStartX - touchEndX;
      const swipeDistanceY = Math.abs(touchStartY - touchEndY);
      const minSwipeDistance = 60;
      
      // Only handle swipe if horizontal movement is greater than vertical
      // and meets minimum distance requirement
      if (Math.abs(swipeDistance) > minSwipeDistance && Math.abs(swipeDistance) > swipeDistanceY) {
        if (swipeDistance > 0) {
          // Swipe left - next slide
          nextSlide();
        } else {
          // Swipe right - previous slide
          const prev = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
          showSlide(prev);
        }
      }
    }
    
    // Handle window resize to update image visibility
    window.addEventListener('resize', function() {
      if (slides[currentSlide]) {
        updateImagesVisibility(slides[currentSlide], currentSlide);
      }
    });
    
    // Initialize
    showSlide(0);
    
    // Auto-slide will start automatically when slider becomes visible
    // via the Intersection Observer
    
    console.log('Income slider initialized successfully');
    
    // Cleanup function for the observer
    window.incomeSliderCleanup = function() {
      if (sliderObserver) {
        sliderObserver.disconnect();
      }
      stopAutoSlide();
    };
  }
  
  // Also try to reinitialize when Shopify reloads sections
  document.addEventListener('shopify:section:load', function() {
    // Cleanup previous observer if exists
    if (window.incomeSliderCleanup) {
      window.incomeSliderCleanup();
    }
    
    setTimeout(function() {
      initIncomeSlider();
    }, 100);
  });
  
  // Cleanup on unload
  window.addEventListener('beforeunload', function() {
    if (window.incomeSliderCleanup) {
      window.incomeSliderCleanup();
    }
  });
});